import React, { useEffect } from 'react';
import { HTTP_RESPONSE_CODES } from '../common/helpers/constants';
import ErrorContent from '../components/error/Error';
import Page from '../layouts/main';
import commonResource from '../locales/th/common.json';
import { NextPageContext, NextPage } from 'next';

interface HTTPResponse {
  statusCode?: number;
}

interface ErrorProps {
  statusCode?: number;
}

const Error: NextPage<ErrorProps> = ({ statusCode }) => {
  useEffect(() => {
    const insert404PageGA = () => {
      const head = document.getElementsByTagName('head')[0];
      if (head) {
        const scriptGALink = document.createElement('script');
        scriptGALink.setAttribute(
          'src',
          'https://www.googletagmanager.com/gtag/js?id=UA-199966006-11',
        );
        const scriptGA = document.createElement('script');
        const scriptGAContent = document.createTextNode(`
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());

          gtag('config', 'UA-199966006-11');
        `);
        head.appendChild(scriptGALink);
        scriptGA.appendChild(scriptGAContent);
        head.appendChild(scriptGA);
      }
    };

    if (statusCode === HTTP_RESPONSE_CODES.NotFound) {
      insert404PageGA();
    }
  }, [statusCode]);

  return (
    <Page>
      {statusCode === HTTP_RESPONSE_CODES.NotFound && (
        <ErrorContent
          title={commonResource.error404Title}
          subtitle={commonResource.error404Subtitle}
          description={commonResource.error404Description}
        />
      )}
      {statusCode >= HTTP_RESPONSE_CODES.ServerError && (
        <ErrorContent
          title={commonResource.error500Title}
          subtitle={commonResource.error500Subtitle}
          description={commonResource.error500Description}
        />
      )}
    </Page>
  );
};

Error.getInitialProps = async ({ res }: NextPageContext) => {
  const statusCode =
    (res as HTTPResponse)?.statusCode ?? HTTP_RESPONSE_CODES.ServerError;
  return { statusCode };
};

export default Error;
